import LandingPageFooter from "../../LandingPage/LandingPageFooter";
import LandingPageHeader from "../../LandingPage/LandingPageHeader";

export default function LandingLayout({ children, isHamburgerMenuActive, setIsHamburgerMenuActive }) {
  return (
    <div
      className="content landing-page overflow-hidden animate__animated animate__fadeInDown"
      style={{ marginLeft: 0, minHeight: "100vh" }}
    >
      <div className="top-bar landing-page h-auto align-content-center">
        <LandingPageHeader
          isHamburgerMenuActive={isHamburgerMenuActive}
          setIsHamburgerMenuActive={setIsHamburgerMenuActive}
        />
      </div>
      <div className="inside-content">{children}</div>
      <LandingPageFooter />
    </div>
  );
}
